import React from 'react';
import { Box, Typography } from '@mui/material';
import PhoneIcon from '@mui/icons-material/Phone';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';

const Hamburger = ({ state, handleMenu }) => {
  const menuItems = [
    {
      title: 'Korean BBQ Edinburgh',
      link: 'https://koreanbbq.kjgroups.co.uk',
      phone: '+44 131 357 6000',
      tag: 'BBQ'
    },
    {
      title: 'Korean BBQ Dundee',
      link: 'https://koreanbbqdundee.kjgroups.co.uk/',
      phone: '+44 138 252 1144',
      tag: 'BBQ'
    },
    {
      title: 'Korean Munchies',
      link: 'https://koreanmunchies.kjgroups.co.uk/',
      phone: '+44 131 285 3038',
      tag: 'Street Food'
    },
    {
      title: 'Soul Sushi',
      link: 'https://soulsushi.kjgroups.co.uk/',
      phone: '+44 131 667 0200',
      tag: 'Sushi'
    },
  ];

  return (
    <Box
      sx={{
        position: 'fixed',
        top: '0',
        right: state.clicked ? '0' : '-100%',
        width: '100%',
        height: '100vh',
        background: 'linear-gradient(135deg, rgba(10, 10, 10, 0.98), rgba(20, 20, 20, 0.98))',
        transition: 'right 0.5s cubic-bezier(0.4, 0, 0.2, 1)',
        backdropFilter: 'blur(30px)',
        zIndex: 998,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        overflow: 'hidden',
        '&::before': {
          content: '""',
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background: 'radial-gradient(circle at 30% 40%, rgba(255, 77, 77, 0.08), transparent 60%), radial-gradient(circle at 70% 60%, rgba(249, 203, 40, 0.06), transparent 60%)',
          pointerEvents: 'none',
        },
        '&::after': {
          content: '""',
          position: 'absolute',
          top: '-50%',
          right: '-10%',
          width: '500px',
          height: '500px',
          borderRadius: '50%',
          background: 'radial-gradient(circle, rgba(255, 77, 77, 0.1), transparent 70%)',
          filter: 'blur(60px)',
          opacity: state.clicked ? 0.6 : 0,
          transition: 'opacity 0.8s ease 0.3s',
          pointerEvents: 'none',
        }
      }}
    >
      {/* Decorative Grid Pattern */}
      <Box
        sx={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background: `
            linear-gradient(90deg, rgba(255,77,77,0.02) 1px, transparent 1px),
            linear-gradient(rgba(255,77,77,0.02) 1px, transparent 1px)
          `,
          backgroundSize: '50px 50px',
          opacity: state.clicked ? 0.4 : 0,
          transition: 'opacity 0.6s ease 0.2s',
          pointerEvents: 'none',
        }}
      />

      {/* Animated Corner Accent */}
      <Box
        sx={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100px',
          height: '100px',
          background: 'linear-gradient(135deg, #FF4D4D, transparent)',
          opacity: state.clicked ? 0.3 : 0,
          transition: 'opacity 0.6s ease 0.4s',
          pointerEvents: 'none',
        }}
      />


      {/* Menu Items */}
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          padding: { xs: '20px', md: '40px' },
          maxWidth: { xs: '100%', sm: '520px', md: '640px' },
          margin: '0 auto',
          gap: { xs: 1.5, md: 2 },
          position: 'relative',
          zIndex: 2,
        }}
      >
        {menuItems.map((item, index) => (
          <Box
            key={index}
            component="a"
            href={item.link}
            target="_blank"
            rel="noopener noreferrer"
            sx={{
              textDecoration: 'none',
              opacity: state.clicked ? 1 : 0,
              transform: state.clicked ? 'translateY(0) scale(1)' : 'translateY(20px) scale(0.95)',
              transition: `all 0.5s cubic-bezier(0.4, 0, 0.2, 1) ${index * 0.1 + 0.4}s`,
              background: 'rgba(255, 255, 255, 0.04)',
              border: '1px solid rgba(255, 255, 255, 0.1)',
              borderRadius: '14px',
              padding: { xs: '14px 16px', md: '18px 20px' },
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              backdropFilter: 'blur(10px)',
              position: 'relative',
              overflow: 'hidden',
              '&::before': {
                content: '""',
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
                background: 'linear-gradient(135deg, rgba(255, 77, 77, 0.1), rgba(249, 203, 40, 0.05))',
                opacity: 0,
                transition: 'opacity 0.3s ease',
              },
              '&::after': {
                content: '""',
                position: 'absolute',
                top: 0,
                left: '-100%',
                width: '100%',
                height: '100%',
                background: 'linear-gradient(90deg, transparent, rgba(255,255,255,0.1), transparent)',
                transition: 'left 0.6s ease',
              },
              '&:hover': {
                background: 'rgba(255, 255, 255, 0.06)',
                borderColor: 'rgba(255, 77, 77, 0.4)',
                transform: 'translateX(6px) scale(1.02)',
                boxShadow: '0 8px 24px rgba(255, 77, 77, 0.2)',
                '&::before': {
                  opacity: 1,
                },
                '&::after': {
                  left: '100%',
                },
                '& .arrow-icon': {
                  transform: 'translateX(6px)',
                  color: '#FF4D4D',
                },
                '& .restaurant-title': {
                  background: 'linear-gradient(135deg, #FF4D4D, #F9CB28)',
                  WebkitBackgroundClip: 'text',
                  WebkitTextFillColor: 'transparent',
                },
                '& .tag-badge': {
                  background: 'linear-gradient(135deg, #FF4D4D, #F9CB28)',
                  transform: 'scale(1.05)',
                }
              }
            }}
          >
            <Box sx={{ flex: 1, position: 'relative', zIndex: 1 }}>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 0.5 }}>
                <Typography
                  className="restaurant-title"
                  sx={{
                    fontSize: { xs: '1.05rem', md: '1.25rem' },
                    fontWeight: 700,
                    color: '#fff',
                    transition: 'all 0.3s ease',
                  }}
                >
                  {item.title}
                </Typography>
                <Box
                  className="tag-badge"
                  sx={{
                    px: 1,
                    py: 0.3,
                    borderRadius: '6px',
                    background: 'rgba(255, 77, 77, 0.15)',
                    border: '1px solid rgba(255, 77, 77, 0.3)',
                    transition: 'all 0.3s ease',
                  }}
                >
                  <Typography
                    sx={{
                      fontSize: { xs: '0.65rem', md: '0.7rem' },
                      color: '#fff',
                      fontWeight: 600,
                      letterSpacing: '0.5px',
                      textTransform: 'uppercase',
                    }}
                  >
                    {item.tag}
                  </Typography>
                </Box>
              </Box>
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: 0.6,
                  color: 'rgba(255,255,255,0.5)',
                }}
              >
                <PhoneIcon sx={{ fontSize: { xs: '0.875rem', md: '1rem' } }} />
                <Typography
                  sx={{
                    fontSize: { xs: '0.8rem', md: '0.9rem' },
                    fontWeight: 500,
                  }}
                >
                  {item.phone}
                </Typography>
              </Box>
            </Box>

            <Box
              sx={{
                width: { xs: '36px', md: '40px' },
                height: { xs: '36px', md: '40px' },
                borderRadius: '10px',
                background: 'rgba(255, 255, 255, 0.05)',
                border: '1px solid rgba(255, 255, 255, 0.1)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                position: 'relative',
                zIndex: 1,
              }}
            >
              <ArrowForwardIcon
                className="arrow-icon"
                sx={{
                  fontSize: { xs: '1.1rem', md: '1.25rem' },
                  color: 'rgba(255,255,255,0.6)',
                  transition: 'all 0.3s ease',
                }}
              />
            </Box>
          </Box>
        ))}
      </Box>

      {/* Bottom Accent Line */}
      <Box
        sx={{
          position: 'absolute',
          bottom: 0,
          left: '50%',
          transform: 'translateX(-50%)',
          width: state.clicked ? '60%' : '0%',
          height: '2px',
          background: 'linear-gradient(90deg, transparent, #FF4D4D, #F9CB28, transparent)',
          transition: 'width 0.8s ease 0.6s',
        }}
      />
    </Box>
  );
};

export default Hamburger;
